
    var riot = require('riot')
    
riot.tag2('gmap-embed', '<div class="v-gmap-embed"> <iframe riot-src="{gmaps.api}?{setOpts()}" riot-style="{setStyle()};"></iframe> <div class="v-gmap-embed__btn"><a href="{setLink()}" target="_blank"><i class="ion-ios-location"></i><span>大きい地図で見る</span></a></div> </div>', 'gmap-embed { display: block; } gmap-embed:not(:last-child) { margin-bottom: 30px; } @media only screen and (max-width: 787px) { gmap-embed { padding: 0 15px; } } gmap-embed .v-gmap-embed iframe { display: block; } gmap-embed .v-gmap-embed__btn { padding-top: 12px; text-align: right; } gmap-embed .v-gmap-embed__btn a { font-size: 16px; display: -webkit-box; display: -webkit-flex; display: -ms-flexbox; display: flex; -webkit-flex-wrap: wrap; -ms-flex-wrap: wrap; flex-wrap: wrap; -webkit-box-align: center; -webkit-align-items: center; -ms-flex-align: center; align-items: center; -webkit-box-pack: end; -webkit-justify-content: flex-end; -ms-flex-pack: end; justify-content: flex-end; } gmap-embed .v-gmap-embed__btn a i { display: inline-block; margin-right: 5px; color: #118dd4; }', '', function(opts) {
    const self = this
    self.height = 0
    self.gmaps = {
      api: 'https://www.google.com/maps/embed/v1/place',
      opts: {
        key: null,
        center: `${self.opts.lat}, ${self.opts.lng}`,
        q: `${self.opts.lat}, ${self.opts.lng}`,

        zoom: 16,
      },
      keys: {
        master: 'AIzaSyATJ0Ie5dhFElOa9y0Gk9UQuMgkwsZ3Q2A',
        test: 'AIzaSyBzsMx9GGqqpAOKqxQlhnr2GKzMOasw-4I',
      }
    }

    this.setOpts = function() {
      if( location.hostname.indexOf('biwako-visitors.jp') !== -1 ){
        self.gmaps.opts.key = self.gmaps.keys.master
      } else {
        self.gmaps.opts.key = self.gmaps.keys.test
      }
      let params = $.param(self.gmaps.opts)
      return params
    }.bind(this)

    this.setLink = function() {
      return `https://www.google.com/maps/place/${self.opts.lat},${self.opts.lng}/@${self.opts.lat},${self.opts.lng},${self.gmaps.opts.zoom}z`
    }.bind(this)

    this.setStyle = function() {
      let w = $("#cont").width()
      let h = w * 0.75

      if ( $(window).width() < 787 ) {
        w = $("#cont").width() - 30
        h = w * 1
      }

      return `
        width: ${w}px;
        height: ${h}px
      `
    }.bind(this)

    self.on('mount', () => {
      $(window).on('load resize orientationchange', () => {
        self.update()
      })
    })

});
    
  


// WEBPACK FOOTER //
// ./_src/js/riot/gmap/gmap-embed.tag